define(function (require) {

    window.lpTag = window.lpTag || {};

    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var Lobs = require('web-agent-assets-js/lpLobs');
    var lpBaseInfoController = require('web-agent-assets-js/lpBaseInfoController');

    lpTag.lpLobsController = function (model) {
        this.applicationType = "lpLobsController";
        var logger = WebAgentLogger.getLogger(this.applicationType);

        var lobsApi;

        this.getLob = function (data) {
            getLob(data);
        };

        this.getSingleLobObject = function (lobObject, name) {
            return getSingleLobObject(lobObject, name);
        };
        initializeApi();

        function initializeApi() {
            lobsApi = new Lobs();
        }

        /////////////////////////////// LOB DATA ///////////////////////////////////

        function getLob(data) {
            logger.debug("", "getLob", data);
            var id;
            if (data) {
                id = data.id;
            }
            if (id) {
                var requestObj = {
                    success: lpUtils.callbackContextWrapper(handleLobSuccess, data),
                    error: lpUtils.callbackContextWrapper(handleLobError, data),
                    context: data
                };
                lobsApi.getLob(requestObj, id);
            }
        }

        function handleLobSuccess(data) {
            logger.info("Lob return as Success", "handleLobSuccess");
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            lpTag.lpLobsController.prototype.handleACRequestSuccess(model, data, lpTag.lpLobsController.prototype.serviceNames.lob, getSingleLobObject, context, dataObject);
        }

        function handleLobError(data) {
            logger.error("", "handleLobError", data);
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            lpTag.lpLobsController.prototype.handleRequestError(model, data, lpTag.lpLobsController.prototype.serviceNames.lob, data && data.visitorId, dataObject);
        }

        function getSingleLobObject(lobObject, name) {
            var toReturn = lpTag.lpLobsController.prototype.getDataFromModelIfNotModified(model, this, name) || {
                    id: lobObject.id,
                    description: lobObject.description,
                    name: lobObject.name
                };
            var visitorId = lobObject && (lobObject.visitorId || (lobObject.dataObject && lobObject.dataObject.data && lobObject.dataObject.data.visitorId));
            lpTag.lpLobsController.prototype.addToVisitorInfoById(model, 'lob', toReturn, visitorId, lobObject && lobObject.dataObject, lpTag.lpLobsController.prototype.serviceNames.lob);
            return toReturn;
        }
    };
    lpTag.lpLobsController.prototype = new lpBaseInfoController();

    return lpTag.lpLobsController;

});
